if (!customElements.get("variant-selects")) {
    class e extends HTMLElement {
        constructor() {
            super(),
                (this.sticky = this.dataset.sticky),
                (this.updateUrl = "true" === this.dataset.updateUrl),
                (this.isDisabledFeature = this.dataset.isDisabled),
                this.addEventListener("change", this.onVariantChange),
                (this.other = Array.from(document.querySelectorAll("variant-selects")).filter((e) => e != this)),
                (this.productWrapper = this.closest(".thb-product-detail")),
                (this.productSlider = this.productWrapper.querySelector(".product-images")),
                (this.hideVariants = "true" === this.dataset.hideVariants);
        }
        connectedCallback() {
            this.updateOptions(), this.updateMasterId(), this.setDisabled(), this.setImageSet();
        }
        onVariantChange() {
            this.updateOptions(),
                this.updateMasterId(),
                this.toggleAddButton(!0, "", !1),
                this.updatePickupAvailability(),
                this.removeErrorMessage(),
                this.updateVariantText(),
                this.setDisabled(),
                this.currentVariant ? (this.updateMedia(), this.updateUrl && this.updateURL(), this.updateVariantInput(), this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable()),
                this.updateOther(),
                dispatchCustomEvent("product:variant-change", { variant: this.currentVariant, sectionId: this.dataset.section });
        }
        updateOptions() {
            (this.fieldsets = Array.from(this.querySelectorAll("fieldset"))),
                (this.options = []),
                this.fieldsets.forEach((e, t) => {
                    e.querySelector("select") ? this.options.push(e.querySelector("select").value) : e.querySelectorAll("input").length && this.options.push(e.querySelector("input:checked").value);
                });
        }
        updateVariantText() {
            let e = Array.from(this.querySelectorAll("fieldset"));
            e.forEach((e, t) => {
                let i = e.querySelector(".form__label__value");
                i && (i.innerHTML = this.options[t]);
            });
        }
        updateMasterId() {
            this.currentVariant = this.getVariantData().find((e) => !e.options.map((e, t) => this.options[t] === e).includes(!1));
        }
        updateOther() {
            if ("false" !== this.dataset.updateUrl && this.other.length) {
                let e = Array.from(this.other[0].querySelectorAll("fieldset"));
                this.options.forEach((t, i) => {
                    e[i].querySelector("select") ? (e[i].querySelector("select").value = t) : e[i].querySelectorAll("input").length && (e[i].querySelector(`input[value='${t}']`).checked = !0);
                }),
                    this.other[0].updateOptions(),
                    this.other[0].updateMasterId(),
                    this.other[0].updateVariantText(),
                    this.other[0].setDisabled();
            }
        }
        updateMedia() {
            if (!this.currentVariant || !this.currentVariant.featured_media) return;
            let e = document.querySelector(".thb-product-detail .product-images"),
                t = document.querySelector(".thb-product-detail #Product-Thumbnails");
            this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, e, t);
        }
        setActiveMedia(e, t, i, s) {
            let r = Flickity.data(i),
                a = i.querySelector(e);
            if (r && this.hideVariants) {
                if (
                    (i.querySelector(".product-images__slide.is-initial-selected") && i.querySelector(".product-images__slide.is-initial-selected").classList.remove("is-initial-selected"),
                    [].forEach.call(i.querySelectorAll(".product-images__slide-item--variant"), function (e) {
                        e.classList.remove("is-active");
                    }),
                    a.classList.add("is-active"),
                    a.classList.add("is-initial-selected"),
                    this.setImageSetMedia(),
                    s)
                ) {
                    let n = s.querySelector(t);
                    s.querySelector(".product-thumbnail.is-initial-selected") && s.querySelector(".product-thumbnail.is-initial-selected").classList.remove("is-initial-selected"),
                        [].forEach.call(s.querySelectorAll(".product-images__slide-item--variant"), function (e) {
                            e.classList.remove("is-active");
                        }),
                        n.classList.add("is-active"),
                        n.classList.add("is-initial-selected");
                }
                i.reInit(this.imageSetIndex), i.selectCell(e);
            } else r && i.selectCell(e);
        }
        updateURL() {
            this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }
        updateShareUrl() {
            let e = document.getElementById(`Share-${this.dataset.section}`);
            e && e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
        }
        updateVariantInput() {
            let e = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
            e.forEach((e) => {
                let t = e.querySelector('input[name="id"]');
                (t.value = this.currentVariant.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
            });
        }
        updatePickupAvailability() {
            let e = document.querySelector(".pickup-availability-wrapper");
            e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), (e.innerHTML = "")));
        }
        removeErrorMessage() {
            let e = this.closest("section");
            if (!e) return;
            let t = e.querySelector("product-form");
            t && t.handleErrorMessage();
        }
        getSectionsToRender() {
            return [
                `price-${this.dataset.section}`,
                `price-${this.dataset.section}--sticky`,
                `product-image-${this.dataset.section}--sticky`,
                `inventory-${this.dataset.section}`,
                `sku-${this.dataset.section}`,
                `quantity-${this.dataset.section}`,
            ];
        }
        renderProductInfo() {
            let e = this.getSectionsToRender();
            fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
                .then((e) => e.text())
                .then((t) => {
                    let i = new DOMParser().parseFromString(t, "text/html");
                    e.forEach((e) => {
                        let t = document.getElementById(e),
                            s = i.getElementById(e);
                        s && t && (t.innerHTML = s.innerHTML);
                        let r = document.getElementById(e),
                            a = document.getElementById(e + "--sticky");
                        r && r.classList.remove("visibility-hidden"), a && a.classList.remove("visibility-hidden");
                    }),
                        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
                });
        }
        toggleAddButton(e = !0, t = !1, i = !0) {
            let s = document.getElementById(`product-form-${this.dataset.section}`);
            if (!s) return;
            let r = s.closest(".product-form").getAttribute("template"),
                a = document.querySelectorAll(".single-add-to-cart-button");
            if (
                a &&
                (a.forEach((i) => {
                    let s = i.querySelector(".single-add-to-cart-button--text");
                    s &&
                        (e
                            ? (i.setAttribute("disabled", "disabled"), t && (s.textContent = t))
                            : (i.removeAttribute("disabled"), i.classList.remove("loading"), r?.includes("pre-order") ? (s.textContent = window.theme.variantStrings.preOrder) : (s.textContent = window.theme.variantStrings.addToCart)));
                }),
                !i)
            )
                return;
        }
        setUnavailable() {
            let e = document.querySelectorAll(".single-add-to-cart-button"),
                t = document.getElementById(`price-${this.dataset.section}`),
                i = document.getElementById(`price-${this.dataset.section}--sticky`);
            e.forEach((e) => {
                let t = e.querySelector(".single-add-to-cart-button--text");
                e && ((t.textContent = window.theme.variantStrings.unavailable), e.classList.add("sold-out"));
            }),
                t && t.classList.add("visibility-hidden"),
                i && i.classList.add("visibility-hidden");
        }
setDisabled() {
    if ("true" != this.isDisabledFeature) return;
    let e = this.getVariantData();
    console.log(e, "eee");
    if (e && this.currentVariant) {
        let t = this.currentVariant.options.map((e, t) => ({ value: e, index: `option${t + 1}` })),
            i = this.createAvailableOptionsTree(e, t);
        this.fieldsets.forEach((e, t) => {
            let s = Object.values(i)[t];
            if (s) {
                // Проверяем наличие select
                if (e.querySelector("select")) {
                    s.forEach((t) => {
                        // Находим <option>
                        let optionElement = e.querySelector("option[value=" + JSON.stringify(t.value) + "]");
                        // Проверяем, найден ли элемент
                        if (optionElement) {
                            optionElement.disabled = t.isUnavailable;
                        }
                    });
                }
                // Проверяем наличие input (например, радио-кнопки)
                else if (e.querySelectorAll("input").length) {
                    e.querySelectorAll("input").forEach((input, index) => {
                        input.classList.toggle("is-disabled", s[index].isUnavailable);
                    });
                }
            }
        });
    }
    return !0;
}
        getImageSetName(e) {
            return e
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "");
        }
        setImageSet() {
            if (!this.productSlider) return;
            let e = this.productSlider.querySelector("[data-set-name]");
            e &&
                ((this.imageSetName = e.dataset.setName),
                (this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index),
                (this.dataset.imageSetIndex = this.imageSetIndex),
                this.setImageSetMedia());
        }
        setImageSetMedia() {
            if (!this.imageSetIndex) return;
            let e = this.getImageSetName(this.currentVariant[this.imageSetIndex]),
                t = this.imageSetName + "_" + e,
                i = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
                s = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
            this.hideVariants &&
                (this.productWrapper.querySelectorAll(".product-images__slide").forEach((e) => {
                    e.dataset.group && e.dataset.group !== t && e.classList.remove("is-active");
                }),
                i.forEach((e) => {
                    e.classList.toggle("is-active", e.dataset.group === t);
                }),
                this.productWrapper.querySelectorAll(".product-thumbnail").forEach((e) => {
                    e.dataset.group && e.dataset.group !== t && e.classList.remove("is-active");
                }),
                s.forEach((e) => {
                    e.classList.toggle("is-active", e.dataset.group === t);
                }));
        }
        createAvailableOptionsTree(e, t) {
            return e.reduce(
                (e, i) => (
                    Object.keys(e).forEach((s) => {
                        if (null === i[s]) return;
                        let r = e[s].find((e) => e.value === i[s]);
                        void 0 === r && ((r = { value: i[s], isUnavailable: !0 }), e[s].push(r));
                        let a = t.reduce((e, { value: t, index: s }) => (i[s] === t ? e + 1 : e), 0);
                        a >= t.length - 1 && (r.isUnavailable = (!r.isUnavailable || !i.available) && r.isUnavailable),
                            (!this.currentVariant || !this.currentVariant.available) && t.find((e) => e.value === r.value && s === e.index) && (r.isUnavailable = !0),
                            "option1" === s && (r.isUnavailable = (!r.isUnavailable || !i.available) && r.isUnavailable);
                    }),
                    e
                ),
                { option1: [], option2: [], option3: [] }
            );
        }
        getVariantData() {
            return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
        }
    }
    customElements.define("variant-selects", e);
    class t extends e {
        constructor() {
            super();
        }
        updateOptions() {
            let e = Array.from(this.querySelectorAll("fieldset"));
            this.options = e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value);
        }
    }
    customElements.define("variant-radios", t);
}
if (!customElements.get("product-slider")) {
    class i extends HTMLElement {
        constructor() {
            super(), this.addEventListener("change", this.setupProductGallery);
        }
        connectedCallback() {
            (this.product_container = this.closest(".thb-product-detail")),
                (this.thumbnail_container = this.product_container.querySelector(".product-thumbnail-container")),
                (this.video_containers = this.querySelectorAll(".product-single__media-external-video--play")),
                this.setOptions(),
                this.init();
        }
        setOptions() {
            (this.hide_variants = "true" == this.dataset.hideVariants),
                (this.thumbnails = this.thumbnail_container.querySelectorAll(".product-thumbnail")),
                (this.prev_button = this.querySelector(".flickity-prev")),
                (this.next_button = this.querySelector(".flickity-next")),
                (this.options = { wrapAround: !0, pageDots: !0, contain: !0, adaptiveHeight: !0, initialIndex: ".is-initial-selected", prevNextButtons: !1, fade: !1, cellSelector: ".product-images__slide.is-active" });
        }
        init() {
            (this.flkty = new Flickity(this, this.options)), (this.selectedIndex = this.flkty.selectedIndex), this.setupEvents(), this.setupProductGallery();
        }
        reInit(e) {
            this.flkty.destroy(), this.setOptions(), (this.flkty = new Flickity(this, this.options)), this.setupEvents(), (this.selectedIndex = this.flkty.selectedIndex);
        }
        setupEvents() {
            let e = this;
            if (this.prev_button) {
                let t = this.prev_button.cloneNode(!0);
                this.prev_button.parentNode.append(t),
                    this.prev_button.remove(),
                    t.addEventListener("click", (e) => {
                        this.flkty.previous();
                    }),
                    t.addEventListener("keyup", (e) => {
                        this.flkty.previous(), e.preventDefault();
                    });
            }
            if (this.next_button) {
                let i = this.next_button.cloneNode(!0);
                this.next_button.parentNode.append(i),
                    this.next_button.remove(),
                    i.addEventListener("click", (e) => {
                        this.flkty.next();
                    }),
                    i.addEventListener("keyup", (e) => {
                        this.flkty.next(), e.preventDefault();
                    });
            }
            this.video_containers.forEach((e) => {
                e.querySelector("button").addEventListener("click", function () {
                    e.setAttribute("hidden", "");
                });
            }),
                this.flkty.on("settle", function (t) {
                    e.selectedIndex = t;
                }),
                this.flkty.on("change", (t) => {
                    let i = this.flkty.cells[e.selectedIndex].element.querySelector(".product-single__media"),
                        s = Array.from(this.thumbnails).filter((e) => e.classList.contains("is-active")),
                        r = s[t] ? s[t] : s[0];
                    this.thumbnails.forEach((e, t) => {
                        e.classList.remove("is-initial-selected");
                    }),
                        r.classList.add("is-initial-selected"),
                        requestAnimationFrame(() => {
                            if (null === r.offsetParent) return;
                            let e = r.offsetParent.clientHeight / 2,
                                t = r.offsetParent.clientWidth / 2;
                            r.parentElement.scrollTo({ left: r.offsetLeft - t + r.clientWidth / 2, top: r.offsetTop - e + r.clientHeight / 2, behavior: "smooth" });
                        }),
                        i.classList.contains("product-single__media-external-video")
                            ? ("youtube" === i.dataset.provider
                                  ? i.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ event: "command", func: "pauseVideo", args: "" }), "*")
                                  : "vimeo" === i.dataset.provider && i.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "pause" }), "*"),
                              i.querySelector(".product-single__media-external-video--play").removeAttribute("hidden"))
                            : i.classList.contains("product-single__media-native-video") && i.querySelector("video").pause();
                }),
                setTimeout(() => {
                    Array.from(this.thumbnails)
                        .filter((e) => e.clientWidth > 0)
                        .forEach((e, t) => {
                            e.addEventListener("click", () => {
                                this.thumbnailClick(e, t);
                            });
                        });
                });
        }
        thumbnailClick(e, t) {
            [].forEach.call(this.thumbnails, function (e) {
                e.classList.remove("is-initial-selected");
            }),
                e.classList.add("is-initial-selected"),
                this.flkty.select(t);
        }
        setDraggable(e) {
            (this.flkty.options.draggable = e), this.flkty.updateDraggable();
        }
        selectCell(e) {
            this.flkty.selectCell(e);
        }
        setupProductGallery() {
            this.querySelectorAll(".product-single__media-zoom").length && this.setEventListeners();
        }
        buildItems() {
            return (
                (this.activeImages = Array.from(this.querySelectorAll(".product-images__slide.is-active .product-single__media-image"))),
                this.activeImages.map((e) => {
                    let t = [].indexOf.call(e.parentNode.parentNode.children, e.parentNode),
                        i = e.querySelector(".product-single__media-zoom");
                    return (i.dataset.index = t), { src: i.getAttribute("href"), msrc: i.dataset.msrc, w: i.dataset.w, h: i.dataset.h };
                })
            );
        }
        setEventListeners() {
            (this.links = this.querySelectorAll(".product-single__media-zoom")),
                (this.pswpElement = document.querySelectorAll(".pswp")[0]),
                (this.pswpOptions = {
                    maxSpreadZoom: 2,
                    loop: !1,
                    allowPanToNext: !1,
                    closeOnScroll: !1,
                    showHideOpacity: !1,
                    arrowKeys: !0,
                    history: !1,
                    captionEl: !1,
                    fullscreenEl: !1,
                    zoomEl: !1,
                    shareEl: !1,
                    counterEl: !0,
                    arrowEl: !0,
                    preloaderEl: !0,
                    getThumbBoundsFn: () => {
                        let e = this.querySelector(".product-images__slide.is-selected"),
                            t = window.pageYOffset || document.documentElement.scrollTop,
                            i = e.getBoundingClientRect();
                        return { x: i.left, y: i.top + t, w: i.width };
                    },
                }),
                this.links.forEach((e) => {
                    e.addEventListener("click", (t) => this.zoomClick(t, e));
                });
        }
        zoomClick(e, t) {
            if (((this.items = this.buildItems()), (this.pswpOptions.index = parseInt(t.dataset.index, 10)), "undefined" != typeof PhotoSwipe)) {
                let i = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
                i.listen("firstUpdate", function () {
                    i.listen("parseVerticalMargin", function (e) {
                        e.vGap = { top: 50, bottom: 50 };
                    });
                }),
                    i.init();
            }
            e.preventDefault();
        }
    }
    customElements.define("product-slider", i);
}
if (
    (customElements.get("product-form") ||
        customElements.define(
            "product-form",
            class e extends HTMLElement {
                constructor() {
                    super(),
                        (this.sticky = this.dataset.sticky),
                        (this.form = document.getElementById(`product-form-${this.dataset.section}`)),
                        (this.form.querySelector("[name=id]").disabled = !1),
                        this.sticky || this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
                        (this.cartNotification = document.querySelector("cart-notification")),
                        (this.body = document.body),
                        (this.hideErrors = "true" === this.dataset.hideErrors);
                }
                onSubmitHandler(e) {
                    if ((e.preventDefault(), !this.form.reportValidity())) return;
                    let t = document.querySelectorAll(".single-add-to-cart-button");
                    t.forEach((e) => {
                        e.classList.contains("loading") || (e.setAttribute("aria-disabled", !0), e.classList.add("loading"));
                    }),
                        this.handleErrorMessage();
                    let i = { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" } },
                        s = new FormData(this.form);
                    s.append(
                        "sections",
                        this.getSectionsToRender().map((e) => e.section)
                    ),
                        s.append("sections_url", window.location.pathname),
                        (i.body = s),
                        fetch(`${theme.routes.cart_add_url}`, i)
                            .then((e) => e.json())
                            .then((e) => {
                                if (e.status) {
                                    dispatchCustomEvent("product:variant-error", { source: "product-form", productVariantId: s.get("id"), errors: e.description, message: e.message }), this.handleErrorMessage(e.description);
                                    return;
                                }
                                this.renderContents(e), dispatchCustomEvent("cart:item-added", { product: e.hasOwnProperty("items") ? e.items[0] : e });
                            })
                            .catch((e) => {
                                console.error(e);
                            })
                            .finally(() => {
                                t.forEach((e) => {
                                    e.classList.remove("loading"), e.removeAttribute("aria-disabled");
                                });
                            });
                }
                getSectionsToRender() {
                    return [
                        { id: "Cart", section: "main-cart", selector: ".thb-cart-form" },
                        { id: "Cart-Drawer", section: "cart-drawer", selector: ".cart-drawer" },
                        { id: "cart-drawer-toggle", section: "cart-bubble", selector: ".thb-item-count" },
                    ];
                }
                renderContents(e) {
                    this.getSectionsToRender().forEach((t) => {
                        if (!document.getElementById(t.id)) return;
                        let i = document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id);
                        (i.innerHTML = this.getSectionInnerHTML(e.sections[t.section], t.selector)), "undefined" != typeof CartDrawer && new CartDrawer(), "undefined" != typeof Cart && new Cart().renderContents(e);
                    });
                    let t = document.getElementById("Product-Drawer"),
                        i = document.getElementById("Search-Drawer");
                    i.classList.contains("active") && i.classList.remove("active"),
                        t && t.contains(this)
                            ? (t.classList.remove("active"),
                              this.body.classList.remove("open-cc--product"),
                              document.getElementById("Cart-Drawer") && (this.body.classList.add("open-cc"), document.getElementById("Cart-Drawer").classList.add("active")))
                            : document.getElementById("Cart-Drawer") && (this.body.classList.add("open-cc"), document.getElementById("Cart-Drawer").classList.add("active"), dispatchCustomEvent("cart-drawer:open"));
                }
                getSectionInnerHTML(e, t = ".shopify-section") {
                    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
                }
                handleErrorMessage(e = !1) {
                    !this.hideErrors &&
                        ((this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
                        this.errorMessageWrapper &&
                            ((this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
                            this.errorMessageWrapper.toggleAttribute("hidden", !e),
                            e && (this.errorMessage.textContent = e)));
                }
            }
        ),
    !customElements.get("product-add-to-cart-sticky"))
) {
    class s extends HTMLElement {
        constructor() {
            super(), (this.animations_enabled = document.body.classList.contains("animations-true") && "undefined" != typeof gsap);
        }
        connectedCallback() {
            this.setupObservers(), this.setupToggle();
        }
        setupToggle() {
            let e = this.querySelector(".product-add-to-cart-sticky--inner"),
                t = this.querySelector(".product-add-to-cart-sticky--content");
            if (this.animations_enabled) {
                let i = gsap.timeline({
                    reversed: !0,
                    paused: !0,
                    onStart() {
                        e.classList.add("sticky-open");
                    },
                    onReverseComplete() {
                        e.classList.remove("sticky-open");
                    },
                });
                i.set(t, { display: "block", height: "auto" }, "start").from(t, { height: 0, duration: 0.25 }, "start+=0.001"),
                    e.addEventListener("click", function () {
                        return i.reversed() ? i.play() : i.reverse(), !1;
                    });
            } else
                e.addEventListener("click", function () {
                    return t.classList.toggle("active"), !1;
                });
        }
        setupObservers() {
            let e = this,
                t = new IntersectionObserver(
                    function (t) {
                        t.forEach((t) => {
                            if ((t.target === s && (t.intersectionRatio > 0 ? e.classList.remove("sticky--visible") : 0 == t.intersectionRatio && e.formPassed && e.classList.add("sticky--visible")), t.target === i)) {
                                let r = i.getBoundingClientRect();
                                0 === t.intersectionRatio && window.scrollY > r.top + r.height
                                    ? ((e.formPassed = !0), e.classList.add("sticky--visible"))
                                    : 1 === t.intersectionRatio && ((e.formPassed = !1), e.classList.remove("sticky--visible"));
                            }
                        });
                    },
                    { threshold: [0, 1] }
                ),
                i = document.getElementById(`product-form-${this.dataset.section}`),
                s = document.getElementById("footer");
            (e.formPassed = !1), t.observe(i), t.observe(s);
        }
    }
    customElements.define("product-add-to-cart-sticky", s);
}
if (!customElements.get("side-panel-links")) {
    class r extends HTMLElement {
        constructor() {
            super(),
                (this.links = this.querySelectorAll("button")),
                (this.drawer = document.getElementById("Product-Information-Drawer")),
                (this.buttons = this.drawer.querySelector(".side-panel-content--tabs")),
                (this.panels = this.drawer.querySelector(".side-panel-content--inner").querySelectorAll(".side-panel-content--tab-panel")),
                (this.body = document.body);
        }
        connectedCallback() {
            this.setupObservers();
        }
        disconnectedCallback() {}
        setupObservers() {
            this.links.forEach((e, t) => {
                e.addEventListener("click", (e) => {
                    this.body.classList.add("open-cc"), this.buttons.toggleActiveClass(t), this.drawer.classList.add("active");
                });
            });
        }
    }
    customElements.define("side-panel-links", r);
}
